import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=0efb8cc4&"
import script from "./MobileHeader.vue?vue&type=script&lang=js&"
export * from "./MobileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports